import {
  EraResponse,
  GetSuperstarParams,
  MySuperstarListResponse,
  MySuperstarResponse,
  SuperstarDetailsResponse,
  SuperstarResponse,
  SuperstarSearchResponse,
  SuperstarSuggestionsResponse,
} from '@wwe-portal/entities/superstar.type';
import { nestApiClient } from './api-client';
import { SuperstarStatsSheetResponse } from '@wwe-portal/entities/superstar-stats.type';

export const getSuperstars = () => {
  return nestApiClient.get<SuperstarResponse>('/wrestlers/v2');
};

export const getSuperstarDetails = (name: string) => {
  return nestApiClient.get<SuperstarStatsSheetResponse>(
    `/superstar-guide/superstars/${name}`
  );
};

export const getSuperstarDetailsLegacy = (name: string) => {
  return nestApiClient.get<SuperstarDetailsResponse>(`/wrestlers/v2/${name}`);
};

export const getAllSuperstars = (params?: GetSuperstarParams) => {
  return nestApiClient.get<SuperstarResponse>(
    '/superstar-guide/superstars/all',
    {
      params,
    }
  );
};

export const getMySuperstars = (params: GetSuperstarParams) => {
  return nestApiClient.get<MySuperstarListResponse>(
    '/superstar-guide/superstars/owned',
    {
      params,
    }
  );
};

export const getMySuperstarById = (id: string) => {
  return nestApiClient.get<MySuperstarResponse>(
    `/superstar-guide/superstars/owned/${id}`
  );
};

export const getTrendingSuperstars = (params?: {
  skip: number;
  perPage: number;
}) => {
  return nestApiClient.get<SuperstarResponse>(
    '/superstar-guide/superstars/trending',
    {
      params,
    }
  );
};

export const getSearchSuperstars = (params?: {
  keyword: string;
  limit: number;
  class?: string;
  tier?: string;
  era?: string;
  owned?: 'true';
  playStyle?: string;
}) => {
  return nestApiClient.get<SuperstarSearchResponse>('/superstar-guide/search', {
    params,
  });
};

export const getSuggestions = (params?: { keyword: string }) => {
  return nestApiClient.get<SuperstarSuggestionsResponse>(
    '/superstar-guide/search/suggestions',
    {
      params,
    }
  );
};

export const getEras = () => {
  return nestApiClient.get<EraResponse>('/superstar-guide/superstars/tags/Era');
};
